var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createTheme } from "@mui/material";
import { baseColors, colors } from "./colors";
import { getTypography } from "./Typography";
var _a = createTheme(), breakpoints = _a.breakpoints, muiShadows = _a.shadows;
var customShadows = __spreadArray([], muiShadows, true);
customShadows[1] = '0px 1px 2px 0px #00000014';
customShadows[2] = '0px 2px 4px -2px #0000000D';
var defaultTheme = createTheme({
    shadows: customShadows,
    palette: {
        primary: {
            main: baseColors.bluePreset[10],
        },
        text: {
            primary: baseColors.darkPreset[10],
            disabled: baseColors.greyPreset[30],
        },
    },
    typography: getTypography(breakpoints),
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                '*, *::before, *::after': {
                    fontFamily: "'Nunito', sans-serif",
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: "capitalize",
                },
                outlined: {
                    color: colors.blueShades[12],
                    borderColor: colors.blueShades[12],
                    "&:hover": {
                        borderColor: colors.blueShades[12],
                        backgroundColor: "#f5f8ff",
                    },
                },
                contained: {
                    backgroundColor: colors.blueShades[12],
                    color: "#fff",
                    "&:hover": {
                        backgroundColor: colors.blueShades[12],
                        opacity: 0.9,
                    },
                },
            },
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    color: colors.blueShades[12],
                    '&.Mui-checked': {
                        color: colors.blueShades[12],
                    },
                },
            },
        },
        MuiRadio: {
            styleOverrides: {
                root: {
                    color: colors.blueShades[12],
                    '&.Mui-checked': {
                        color: colors.blueShades[12],
                    },
                },
            },
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    '&:link, &:visited, &:hover, &:active': {
                        color: 'inherit',
                    },
                },
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    lineHeight: 1.5,
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    height: "37px",
                },
            },
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    backgroundColor: '#F5F5F5',
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                paper: {
                    backgroundColor: '#F5F5F5',
                },
            },
        },
    },
});
export default defaultTheme;
